import React from 'react'
import {
  DcInput,
  DcButton,
  PixelFactoryContext,
  PixelFlexBox,
  PixelText,
  colors,
  DcText,
} from 'pixel-base'

import { validateDarazStore } from 'utils/api-routes.util'
import {
  WebsiteDataContainer,
  WebsiteDataTitle,
  WebsiteDataURL,
} from 'app/common/styles/section'
import { IPixelFactory } from '../../../../../decl'
interface IProps {
  origin: string
}
const AddDarazStore = (props: IProps) => {
  const { origin } = props
  const { showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [data, setData] = React.useState({
    store_name: '',
  })
  const [error, setError] = React.useState({ field: '', error: '' })
  const [validatedData, setValidatedData] = React.useState({
    auth_url: '',
    favicon: '',
    id: 0,
    title: '',
    url: '',
    validated: false,
  })

  const handleConnectClick = () => {
    window.open(validatedData.auth_url, '_blank')
  }
  const handleSubmit = () => {
    handleValidateDarazStore(data, setValidatedData)
  }
  const handleValidateDarazStore = (data, setValidatedData) => {
    showPageLoader()
    validateDarazStore({
      ...data,
      origin: origin || 'onboarding',
    }).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        localStorage.setItem(
          'lastDarazStore',
          JSON.stringify(res.response.data),
        )
        setValidatedData(res.response.data)
        hidePageLoader()
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error || res.response.errors)
        }
      }
    })
  }
  return (
    <PixelFlexBox width="100%" height="100%">
      <PixelFlexBox
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        alignContent="stretch"
        gap="20px"
        height="100%"
      >
        <PixelFlexBox
          flexDirection="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          alignContent="flex-start"
          height="100%"
        >
          <DcText
            customColor={colors.grayTextDark}
            style={{
              fontSize: '14px',
              lineHeight: 1.5,
              marginBottom: '20px',
              color: '#64748b',
            }}
          >
            Connect your Daraz store to automatically sync orders, products, and
            streamline your fulfillment with PixelOne.
          </DcText>
          <PixelFlexBox
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            alignContent="flex-start"
            style={{
              borderRadius: '5px',
            }}
            width="100%"
            height="100%"
            padding="20px 0px"
            gap="10px"
          >
            <PixelFlexBox
              flexDirection="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              alignContent="flex-start"
              gap="10px"
            >
              <PixelText
                customColor={colors.grayTextDark}
                style={{
                  fontSize: '.875rem',
                  fontWeight: '500',
                  textAlign: 'left',
                }}
              >
                What is the friendly name of your store?
              </PixelText>
              <DcInput
                placeholder="mystore.daraz.com"
                error={
                  error.field === data.store_name && error.error !== ''
                    ? error.error
                    : null
                }
                value={data.store_name}
                readOnly={validatedData.validated}
                required
                onChange={(e) =>
                  setData({ ...data, store_name: e.target.value })
                }
              />
            </PixelFlexBox>
            {validatedData.validated ? (
              <WebsiteDataContainer>
                <PixelText variant="light">
                  {`We're going to send you to your store now to give PixelOne
                  permission to access your data (orders, customers, etc.).
                  <br /> Then the magic happens.`}
                </PixelText>
                <PixelFlexBox
                  flexDirection="column"
                  justifyContent="space-between"
                  alignItems="flex-start"
                  alignContent="flex-start"
                  style={{ padding: '0px' }}
                  height="auto"
                  gap="10px"
                >
                  <PixelFlexBox flexDirection="column" height="auto">
                    <WebsiteDataTitle>{validatedData.title}</WebsiteDataTitle>
                    <WebsiteDataURL>{validatedData.url}</WebsiteDataURL>
                  </PixelFlexBox>
                  <PixelFlexBox
                    gap="10px"
                    height="auto"
                    justifyContent="flex-end"
                  >
                    <DcButton
                      width="50%"
                      variant="secondary"
                      onClick={() => {
                        setValidatedData({
                          ...validatedData,
                          validated: false,
                        })
                      }}
                    >
                      Change
                    </DcButton>
                    <DcButton
                      width="50%"
                      onClick={handleConnectClick}
                      variant="gradient"
                    >
                      Connect
                    </DcButton>
                  </PixelFlexBox>
                </PixelFlexBox>
              </WebsiteDataContainer>
            ) : (
              <PixelFlexBox
                flexDirection="column"
                justifyContent="flex-end"
                alignItems="flex-start"
                alignContent="flex-start"
                gap="10px"
              >
                <DcButton width="25%" variant="gradient" onClick={handleSubmit}>
                  Connect store
                </DcButton>
              </PixelFlexBox>
            )}
          </PixelFlexBox>
        </PixelFlexBox>
      </PixelFlexBox>
    </PixelFlexBox>
  )
}

export default AddDarazStore
